import { Grid } from "@material-ui/core";
import React from "react";

export function HorizontalCentered(props: React.PropsWithChildren<{}>){
    return <Grid container justify="center" alignItems="center">
        <Grid item>{props.children}</Grid>
    </Grid>
}